<span
  style="margin-top: 0.7em"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.display]="displayCss">
  <button
    #btn
    data-cy="input-button"
    pButton
    type="button"
    [attr.data-cy-channelId]="channelId ? channelId : ''"
    [attr.data-cy-columnName]="data ? data.columnName : columnName"
    [attr.data-cy-formId]="data && data['formId'] ? data['formId'] : ''"
    [attr.data-cy-processId]="data && data['processId'] ? data['processId'] : ''"
    [disabled]="isReadOnly"
    icon="{{ icon || '' }}"
    [label]="label"
    [ngClass]="['p-button', 'p-button-' + (btnType || 'secondary'), !isStandalone ? 'button-field' : '']"></button>
</span>
